export const getDeviceType = () => {
  const userAgentCheck = /Mobile|Tablet|iPad|iPhone|Android/.test(navigator?.userAgent);
  const screenWidthCheck = window.innerWidth <= 768;

  return userAgentCheck || screenWidthCheck ? "mobile" : "desktop";
};
